import { WriteOffLoanFields } from "../containers/personal-loan-details/types";
import { LoanSearchDto, LoanSearchFilterDto } from "../dto";
import { UpdateWCTLApplication } from "../dto/enterprise.dto";
import { CreateInvoiceDto } from "../dto/invoice.dto";
import { MiddlewareAction } from "../middleware";
import {
  AddLoanPayment,
  AddLoanWithdrawal,
  AddTermLoanPayment,
  addWCTLoanDisbursal,
  AddWCTLRepayment,
  AddWCTLTdsCredit,
  LoanDisbursalPayload,
  LoanType,
} from "../models";

export enum Actions {
  REQUEST_GET_LOAN_BY_ID = "REQUEST_GET_LOAN_BY_ID",
  REQUEST_GET_COMMERCIAL_LOAN_BY_ID = "REQUEST_GET_COMMERCIAL_LOAN_BY_ID",
  REQUEST_GET_PAGINATED_LOANS = "REQUEST_GET_PAGINATED_LOANS",
  REQUEST_GET_LOANS_BY_USER_ID = "REQUEST_GET_LOANS_BY_USER_ID",
  REQUEST_GET_LOANS_BY_ENTERPRISE_ID = "REQUEST_GET_LOANS_BY_ENTERPRISE_ID",
  REQUEST_GET_USER_AUDIT_TRAIL = "REQUEST_GET_USER_AUDIT_TRAIL",
  REQUEST_ADD_LOAN_PAYMENT = "REQUEST_ADD_LOAN_PAYMENT",
  REQUEST_ADD_TERM_LOAN_PAYMENT = "REQUEST_ADD_TERM_LOAN_PAYMENT",
  REQUEST_ADD_LOAN_WITHDRAWAL = "REQUEST_ADD_LOAN_WITHDRAWAL",
  REQUEST_GET_LOAN_BY_APPLICATION_ID = "REQUEST_GET_LOAN_BY_APPLICATION_ID",
  REQUEST_GET_LOAN_COUNT = "REQUEST_GET_LOAN_COUNT",
  REQUEST_GET_LOAN_PAGINATION_COUNT = "REQUEST_GET_LOAN_PAGINATION_COUNT",
  REQUEST_GET_LOAN_SEARCH_FILTERS = "REQUEST_GET_LOAN_SEARCH_FILTERS",
  REQUEST_GET_LOANS_BY_SEARCH = "REQUEST_GET_LOANS_BY_SEARCH",
  REQUEST_GET_COMMERICIAL_LOANS_BY_SEARCH = "REQUEST_GET_COMMERICIAL_LOANS_BY_SEARCH",
  REQUEST_ADD_LOAN_DISBURSAL = "REQUEST_ADD_LOAN_DISBURSAL",
  REQUEST_GET_TRANSACTIONS_BY_LOAN_ID = "REQUEST_GET_TRANSACTIONS_BY_LOAN_ID",
  REQUEST_GET_COMMERCIAL_LOAN_STATEMENT_BY_LOAN_ID = "REQUEST_GET_COMMERCIAL_LOAN_STATEMENT_BY_LOAN_ID",
  REQUEST_GET_COMMERCIAL_OD_TRANSACTION_STATEMENT = "REQUEST_GET_COMMERCIAL_OD_TRANSACTION_STATEMENT",
  REQUEST_ADD_COMMERCIAL_OD_TRANSACTION_CHARGE_INTEREST = "REQUEST_ADD_COMMERCIAL_OD_TRANSACTION_CHARGE_INTEREST",
  REQUEST_ADD_COMMERCIAL_OD_TRANSACTION_WITHDRAWAL = "REQUEST_ADD_COMMERCIAL_OD_TRANSACTION_WITHDRAWAL",
  REQUEST_ADD_COMMERCIAL_OD_TRANSACTION_PAYMENT = "REQUEST_ADD_COMMERCIAL_OD_TRANSACTION_PAYMENT",
  REQUEST_ADD_COMMERCIAL_OD_TRANSACTION_TDS_CREDIT = "REQUEST_ADD_COMMERCIAL_OD_TRANSACTION_TDS_CREDIT",
  REQUEST_CREATE_COMMERCIAL_OD_INVOICE_ENTRY = "REQUEST_CREATE_COMMERCIAL_OD_INVOICE_ENTRY",
  REQUEST_GET_TERM_LOAN_REPAYMENT_SPLIT_BY_LOAN_ID = "REQUEST_GET_TERM_LOAN_REPAYMENT_SPLIT_BY_LOAN_ID",
  REQUEST_GET_TERM_LOAN_LEDGER_INFO_BY_LOAN_ID = "REQUEST_GET_TERM_LOAN_LEDGER_INFO_BY_LOAN_ID",
  REQUEST_GET_RETAIL_OD_LEDGER_INFO_BY_LOAN_ID = "REQUEST_GET_RETAIL_OD_LEDGER_INFO_BY_LOAN_ID",
  REQUEST_UPDATE_WCTL_APPLICATION = "REQUEST_UPDATE_WCTL_APPLICATION",
  REQUEST_GET_WORKING_CAPITAL_TERM_LOAN_BY_SEARCH = "REQUEST_GET_WORKING_CAPITAL_TERM_LOAN_BY_SEARCH",
  REQUEST_GET_WCTL_LOAN_DETAILS = "REQUEST_GET_WCTL_LOAN_DETAILS",
  REQUEST_WCTL_REPAYMENT_SCHEDULE = "REQUEST_WCTL_REPAYMENT_SCHEDULE",
  REQUEST_ADD_WCTL_DISBURSAL = "REQUEST_ADD_WCTL_DISBURSAL",
  REQUEST_ADD_WCTL_TDS_CREDIT = "REQUEST_ADD_WCTL_TDS_CREDIT",
  REQUEST_ADD_WCTL_REPAYMENT = "REQUEST_ADD_WCTL_REPAYMENT",
  REQUEST_GET_TERM_LOAN_CREDIT_ACCOUNT_SUMMARY_BY_LOAN_ID = "REQUEST_GET_TERM_LOAN_CREDIT_ACCOUNT_SUMMARY_BY_LOAN_ID",
  REQUEST_GET_DRAWDOWN_LOANS_BY_SEARCH = "REQUEST_GET_DRAWDOWN_LOANS_BY_SEARCH",
  REQUEST_GET_DRAWDOWN_LOAN_BY_DRAWDOWN_ID = "REQUEST_GET_DRAWDOWN_LOAN_BY_DRAWDOWN_ID",
  REQUEST_GET_RETAIL_OD_DRAWDOWN_CREDIT_ACCOUNT_SUMMARY_BY_DRAWDOWN_ID = "REQUEST_GET_RETAIL_OD_DRAWDOWN_CREDIT_ACCOUNT_SUMMARY_BY_DRAWDOWN_ID",
  REQUEST_GET_AGREEMENT_DOCS_BY_LOAN_ID = "REQUEST_GET_AGREEMENT_DOCS_BY_LOAN_ID",
  REQUEST_GET_NOC_SUPPORTED_LANGUAGES = "REQUEST_GET_NOC_SUPPORTED_LANGUAGES",
  REQUEST_REGENERATE_NO_DUE_CERTIFICATE = "REQUEST_REGENERATE_NO_DUE_CERTIFICATE",
  REQUEST_GET_PAYOUT = "REQUEST_GET_PAYOUT",
  REQUEST_GET_SUB_LOAN_LEDGER_INFO_BY_SUB_LOAN_ID = "REQUEST_GET_SUB_LOAN_LEDGER_INFO_BY_SUB_LOAN_ID",
  REQUEST_WRITE_OFF_RETAIL_OD_BY_LOAN_ID = "REQUEST_WRITE_OFF_RETAIL_OD_BY_LOAN_ID",
  REQUEST_WRITE_OFF_TERM_LOAN_BY_LOAN_ID = "REQUEST_WRITE_OFF_TERM_LOAN_BY_LOAN_ID",
  REQUEST_WRITE_OFF_COMMERCIAL_OD_LOAN_BY_LOAN_ID = "REQUEST_WRITE_OFF_COMMERCIAL_OD_LOAN_BY_LOAN_ID",
  REQUEST_WRITE_OFF_WCTL_LOAN_BY_LOAN_ID = "REQUEST_WRITE_OFF_WCTL_LOAN_BY_LOAN_ID",
  REQUEST_GET_RETAIL_OD_WRITE_OFF_COLLECTIONS_BY_LOAN_ID = "REQUEST_GET_RETAIL_OD_WRITE_OFF_COLLECTIONS_BY_LOAN_ID",
  REQUEST_GET_TERM_LOAN_WRITE_OFF_COLLECTIONS_BY_LOAN_ID = "REQUEST_GET_TERM_LOAN_WRITE_OFF_COLLECTIONS_BY_LOAN_ID",
  REQUEST_GET_COMMERCIAL_OD_WRITE_OFF_COLLECTIONS_BY_LOAN_ID = "REQUEST_GET_COMMERCIAL_OD_WRITE_OFF_COLLECTIONS_BY_LOAN_ID",
  REQUEST_GET_WORKING_CAPITAL_TERM_LOAN_WRITE_OFF_COLLECTIONS_BY_LOAN_ID = "REQUEST_GET_WORKING_CAPITAL_TERM_LOAN_WRITE_OFF_COLLECTIONS_BY_LOAN_ID",
  REQUEST_GET_RETAIL_OD_DRAWDOWN_LOAN_REPAYMENT_SPLIT_BY_SUB_LOAN_ID = "REQUEST_GET_RETAIL_OD_DRAWDOWN_LOAN_REPAYMENT_SPLIT_BY_SUB_LOAN_ID",
  REQUEST_GET_SUB_LOANS_TRANSFORMED_REPAYMENT_SCHEDULE_BY_SUB_LOAN_ID = "REQUEST_GET_SUB_LOANS_TRANSFORMED_REPAYMENT_SCHEDULE_BY_SUB_LOAN_ID",
  REQUEST_GET_REPAYMENT_COMMITMENTS_BY_ENTITY_ID = "REQUEST_GET_REPAYMENT_COMMITMENTS_BY_ENTITY_ID",
  REQUEST_CLOSE_CREDIT_LINE_BY_LOAN_ID = "REQUEST_CLOSE_CREDIT_LINE_BY_LOAN_ID",
  REQUEST_GET_TRANSFORMED_REPAYMENT_SCHEDULE_BY_LOAN_ID = "REQUEST_GET_TRANSFORMED_REPAYMENT_SCHEDULE_BY_LOAN_ID",
  REQUEST_POST_GENERATE_LOAN_STATEMENT = "REQUEST_POST_GENERATE_LOAN_STATEMENT",
  REQUEST_GET_UNPAID_REPAYMENT_COMMITMENT_AMOUNT_BY_ENTITY_ID = "REQUEST_GET_UNPAID_REPAYMENT_COMMITMENT_AMOUNT_BY_ENTITY_ID",
}

export function getTermLoanRepaymentSplitByLoadId(
  loanId: string,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_TERM_LOAN_REPAYMENT_SPLIT_BY_LOAN_ID,
    type: "GET",
    url: `/v1/loans/term-loans/${loanId}/repayments-split`,
  };
}

export function getTermLoanLedgerInfoByLoanId(
  loanId: string,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_TERM_LOAN_LEDGER_INFO_BY_LOAN_ID,
    type: "GET",
    url: `/v1/loans/term-loans/${loanId}/ledger-info`,
  };
}

export function getLoanById(loanId: string): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_LOAN_BY_ID,
    type: "GET",
    url: `/loan?loanId=${loanId}`,
  };
}

export function getCommercialLoanById(loanId: string): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_COMMERCIAL_LOAN_BY_ID,
    type: "GET",
    url: `/v1/loans/commercial-ods/${loanId}`,
  };
}

export function getCommercialODLoanStatementByLoanId(
  loanId: string,
  asOf: string,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_COMMERCIAL_LOAN_STATEMENT_BY_LOAN_ID,
    type: "GET",
    url: `/v1/loans/commercial-ods/${loanId}/statement?asOf=${asOf}`,
  };
}

export function getCommercialODTransactionStatementByLoanId(
  loanId: string,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_COMMERCIAL_OD_TRANSACTION_STATEMENT,
    type: "GET",
    url: `/v1/loans/commercial-ods/${loanId}/transactions`,
  };
}

export function addCommercialODTransactionChargeInterest(
  loanId: string,
  onDate: string,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_ADD_COMMERCIAL_OD_TRANSACTION_CHARGE_INTEREST,
    type: "POST",
    url: `/v1/loans/commercial-ods/${loanId}/interest-charge`,
    body: { onDate },
  };
}

export function addCommercialODTransactionWithdrawal(
  loanId: string,
  body: {
    amount: number;
    onDate: string;
  },
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_ADD_COMMERCIAL_OD_TRANSACTION_WITHDRAWAL,
    type: "POST",
    url: `/v1/loans/commercial-ods/${loanId}/withdrawal`,
    body,
  };
}

export function addCommercialODTransactionPayment(
  loanId: string,
  body: {
    amount: number;
    paymentRefId: string;
    source: string;
    paidAt: string;
  },
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_ADD_COMMERCIAL_OD_TRANSACTION_PAYMENT,
    type: "POST",
    url: `/v1/loans/commercial-ods/${loanId}/repayment`,
    body,
  };
}

export function addCommercialODTransactionTDSCredit(
  loanId: string,
  body: {
    amount: number;
    paymentRefId: string;
    source: string;
    paidAt: string;
  },
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_ADD_COMMERCIAL_OD_TRANSACTION_TDS_CREDIT,
    type: "POST",
    url: `/v1/loans/commercial-ods/${loanId}/tds-credit`,
    body,
  };
}

export function createCommercialODInvoiceEntry(
  loanId: string,
  body: CreateInvoiceDto,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_CREATE_COMMERCIAL_OD_INVOICE_ENTRY,
    type: "POST",
    url: `/v1/loans/commercial-ods/${loanId}/invoice`,
    body,
  };
}

export function getPaginatedLoans(
  pageNo: number,
  numberOfEntitiesPerPage: number,
  loanType: LoanType,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_PAGINATED_LOANS,
    type: "POST",
    url: "/loan/paginated-loans",
    body: { pageNo, numberOfEntitiesPerPage, loanType },
  };
}

export function getLoansByUserId(userId: string): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_LOANS_BY_USER_ID,
    type: "GET",
    url: `/loan/user-loans?userId=${userId}`,
  };
}

export function getUserAuditTrail(userId: string): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_USER_AUDIT_TRAIL,
    type: "GET",
    url: `/v1/loan/${userId}/audit-trail`,
  };
}

export function getLoansByEnterpriseId(enterpriseId: string): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_LOANS_BY_ENTERPRISE_ID,
    type: "GET",
    url: "/loan/enterprise-loans",
    queryParams: { enterpriseId },
  };
}

export function addTermLoanPayment(
  addTermLoanPaymentObj: AddTermLoanPayment,
  loanId: string,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_ADD_TERM_LOAN_PAYMENT,
    type: "POST",
    url: `/v1/loans/term-loans/${loanId}/credits`,
    body: addTermLoanPaymentObj,
  };
}

// We are going to deprecate this '/loan/add-payment' endpoint I'm not removing this from the code because same endpoint we are using for both the loan Term Loan & Retail Od Loans to mark the repayment. For now we use '/loan/add-payment' only for Retail Od Loans.
export function addLoanPayment(
  addPaymentObj: AddLoanPayment,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_ADD_LOAN_PAYMENT,
    type: "POST",
    url: "/loan/add-payment",
    body: addPaymentObj,
  };
}

export function addLoanWithdrawal(
  addWithdrawalObj: AddLoanWithdrawal,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_ADD_LOAN_WITHDRAWAL,
    type: "POST",
    url: "/loan/add-withdrawal",
    body: addWithdrawalObj,
  };
}

export function getTransformedRepaymentScheduleByLoanId(
  loanId: string,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_TRANSFORMED_REPAYMENT_SCHEDULE_BY_LOAN_ID,
    type: "GET",
    url: `/v1/loans/term-loans/${loanId}/transformed-repayment-schedule`,
  };
}

export function getLoanByApplicationId(appId: string): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_LOAN_BY_APPLICATION_ID,
    type: "GET",
    url: `/loan/loan-by-appId?appId=${appId}`,
  };
}

export function getLoanCount(): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_LOAN_COUNT,
    type: "GET",
    url: "/loan/loans-count",
  };
}

export function getLoanSearchFilters(loanType: LoanType): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_LOAN_SEARCH_FILTERS,
    type: "GET",
    url: "/loan/search-filters",
    queryParams: { loanType },
    metadata: { loanType },
  };
}

export function getLoansBySearch({
  pageNo,
  numberOfEntitiesPerPage,
  loanType,
  searchText,
  status,
}: LoanSearchDto): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_LOANS_BY_SEARCH,
    type: "GET",
    url: "/loan/search",
    queryParams: {
      pageNo,
      numberOfEntitiesPerPage,
      loanType,
      searchText,
      status,
    },
  };
}

export function getWCTLoansBySearch({
  pageNo,
  numberOfEntitiesPerPage,
  enterpriseId,
  status,
}: LoanSearchDto): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_WORKING_CAPITAL_TERM_LOAN_BY_SEARCH,
    type: "GET",
    url: `/v1/loans/working-capital-term-loans`,
    queryParams: {
      status,
      pageSize: numberOfEntitiesPerPage,
      pageNumber: pageNo,
      enterpriseId,
    },
  };
}

export function getWCTLoanDetails(loanId: string): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_WCTL_LOAN_DETAILS,
    type: "GET",
    url: `/v1/loans/working-capital-term-loans/${loanId}`,
  };
}

export function getWCTLRepaymentSchedule(loanId: string): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_WCTL_REPAYMENT_SCHEDULE,
    type: "GET",
    url: `/v1/loans/working-capital-term-loans/${loanId}/repayment-schedule`,
  };
}

export function getCommercialODLoansBySearch({
  pageNo,
  numberOfEntitiesPerPage,
  status,
}: LoanSearchDto): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_COMMERICIAL_LOANS_BY_SEARCH,
    type: "GET",
    url: "/v1/loans/commercial-ods",
    queryParams: {
      status,
      pageSize: numberOfEntitiesPerPage,
      pageNumber: pageNo,
    },
  };
}

export function getPaginationLoanCount(
  payload: LoanSearchFilterDto,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_LOAN_PAGINATION_COUNT,
    type: "GET",
    url: "/loan/pagination-count",
    queryParams: { ...payload },
  };
}

export function addLoanDisbursal(
  payload: LoanDisbursalPayload,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_ADD_LOAN_DISBURSAL,
    type: "POST",
    url: "/loan/disburse-loan",
    body: payload,
  };
}

export function getTransactionsByLoanId(loanId: string): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_TRANSACTIONS_BY_LOAN_ID,
    type: "GET",
    url: "/loan/loan-transactions",
    queryParams: { loanId },
  };
}

export function getRetailOdLedgerInfoByLoanId(
  loanId: string,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_RETAIL_OD_LEDGER_INFO_BY_LOAN_ID,
    type: "GET",
    url: `/v1/loans/retail-ods/${loanId}/ledger-info`,
  };
}

export function updateWCTLApplication({
  appId,
  body,
}: {
  appId: string;
  body: UpdateWCTLApplication;
}): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_UPDATE_WCTL_APPLICATION,
    type: "PATCH",
    url: `/v1/applications/working-capital-term-loans/${appId}`,
    body,
  };
}
export function updateWCTLoanDisbursal(cxt: {
  loanId: string;
  body: addWCTLoanDisbursal;
}): MiddlewareAction {
  const { loanId, body } = cxt;
  return {
    actionName: Actions.REQUEST_ADD_WCTL_DISBURSAL,
    type: "PATCH",
    url: `/v1/loans/working-capital-term-loans/${loanId}/disbursal-details`,
    body,
  };
}

export function addWCTLTdsCredit(cxt: {
  loanId: string;
  body: AddWCTLTdsCredit;
}): MiddlewareAction {
  const { loanId, body } = cxt;
  return {
    actionName: Actions.REQUEST_ADD_WCTL_TDS_CREDIT,
    type: "POST",
    url: `/v1/loans/working-capital-term-loans/${loanId}/tds-credit`,
    body,
  };
}

export function addWCTLRepayment(cxt: {
  loanId: string;
  body: AddWCTLRepayment;
}): MiddlewareAction {
  const { loanId, body } = cxt;
  return {
    actionName: Actions.REQUEST_ADD_WCTL_REPAYMENT,
    type: "POST",
    url: `/v1/loans/working-capital-term-loans/${loanId}/repayment`,
    body,
  };
}

export function getTermLoanCreditAccountSummaryByLoanId(
  loanId: string,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_TERM_LOAN_CREDIT_ACCOUNT_SUMMARY_BY_LOAN_ID,
    type: "GET",
    url: `/v1/loans/term-loans/${loanId}/credit-account-summary`,
  };
}

export function getDrawdownLoansBySearch({
  numberOfEntitiesPerPage,
  pageNo,
  loanId,
  status,
}: {
  numberOfEntitiesPerPage: number;
  pageNo: number;
  loanId: string;
  status?: string;
}): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_DRAWDOWN_LOANS_BY_SEARCH,
    type: "GET",
    url: `/v1/loans/retail-ods/${loanId}/drawdowns`,
    queryParams: {
      status,
      pageNo,
      numberOfEntitiesPerPage,
    },
  };
}

export function getDrawdownLoanByDrawdownId(
  drawdownId: string,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_DRAWDOWN_LOAN_BY_DRAWDOWN_ID,
    type: "GET",
    url: `/v1/loans/retail-ods/drawdowns/${drawdownId}`,
  };
}

export function getRetailOdDrawdownCreditAccountSummaryByLoanId(
  drawdownId: string,
): MiddlewareAction {
  return {
    actionName:
      Actions.REQUEST_GET_RETAIL_OD_DRAWDOWN_CREDIT_ACCOUNT_SUMMARY_BY_DRAWDOWN_ID,
    type: "GET",
    url: `/loans/subloans/${drawdownId}/credit-account-summary`,
  };
}

export function getAgreementDocsByLoanId(
  loanId: string,
  loanType: Extract<LoanType, "TERM_LOAN" | "RETAIL_OD"> | "TRANSACTION",
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_AGREEMENT_DOCS_BY_LOAN_ID,
    type: "GET",
    url: `/v1/agreement/${loanId}/get-agreement-docs?loanType=${loanType}`,
  };
}

export function getNocSupportedLanguages(): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_NOC_SUPPORTED_LANGUAGES,
    type: "GET",
    url: "/v1/no-due-certificate/supported-languages",
    throwOnError: true,
  };
}

export function regenerateNoc(
  loanId: string,
  loanType: Extract<LoanType, "TERM_LOAN" | "RETAIL_OD"> | "RETAIL_OD_DRAWDOWN",
  language: string,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_REGENERATE_NO_DUE_CERTIFICATE,
    type: "POST",
    url: "/v1/no-due-certificate/regenerate",
    body: {
      loanId,
      loanType,
      language,
    },
    throwOnError: true,
  };
}

export function getPayout(referenceId: string): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_PAYOUT,
    type: "GET",
    url: "/v1/payout",
    queryParams: { referenceId },
  };
}

export function getSubLoanLedgerInfoBySubLoanId(
  subloanId: string,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_SUB_LOAN_LEDGER_INFO_BY_SUB_LOAN_ID,
    type: "GET",
    url: `/loans/subloans/${subloanId}/ledger-info`,
  };
}

export function writeOffRetailOdByLoanId(
  loanId: string,
  body: WriteOffLoanFields,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_WRITE_OFF_RETAIL_OD_BY_LOAN_ID,
    type: "PATCH",
    url: `/loan/retail-od/${loanId}/write-off`,
    body,
  };
}

export function writeOffTermLoanByLoanId(
  loanId: string,
  body: WriteOffLoanFields,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_WRITE_OFF_TERM_LOAN_BY_LOAN_ID,
    type: "PATCH",
    url: `/v1/loans/term-loans/${loanId}/write-off`,
    body,
  };
}

export function writeOffCommercialOdLoanByLoanId(
  loanId: string,
  body: WriteOffLoanFields,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_WRITE_OFF_COMMERCIAL_OD_LOAN_BY_LOAN_ID,
    type: "PATCH",
    url: `/v1/loans/commercial-ods/${loanId}/write-off`,
    body,
  };
}

export function writeOffWctlLoanByLoanId(
  loanId: string,
  body: WriteOffLoanFields,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_WRITE_OFF_WCTL_LOAN_BY_LOAN_ID,
    type: "PATCH",
    url: `/v1/loans/working-capital-term-loans/${loanId}/write-off`,
    body,
  };
}

export function getRetailOdWriteOffCollectionsByLoanId(
  loanId: string,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_RETAIL_OD_WRITE_OFF_COLLECTIONS_BY_LOAN_ID,
    type: "GET",
    url: `/loan/retail-od/${loanId}/write-off/collections`,
  };
}

export function getTermLoanWriteOffCollectionsByLoanId(
  loanId: string,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_TERM_LOAN_WRITE_OFF_COLLECTIONS_BY_LOAN_ID,
    type: "GET",
    url: `/v1/loans/term-loans/${loanId}/write-off/collections`,
  };
}

export function getCommercialOdWriteOffCollectionsByLoanId(
  loanId: string,
): MiddlewareAction {
  return {
    actionName:
      Actions.REQUEST_GET_COMMERCIAL_OD_WRITE_OFF_COLLECTIONS_BY_LOAN_ID,
    type: "GET",
    url: `/v1/loans/commercial-ods/${loanId}/write-off/collections`,
  };
}

export function getWorkingCapitalTermLoanWriteOffCollectionsByLoanId(
  loanId: string,
): MiddlewareAction {
  return {
    actionName:
      Actions.REQUEST_GET_WORKING_CAPITAL_TERM_LOAN_WRITE_OFF_COLLECTIONS_BY_LOAN_ID,
    type: "GET",
    url: `/v1/loans/working-capital-term-loans/${loanId}/write-off/collections`,
  };
}

export function getRetailOdDrawdownLoanRepaymentSplitBySubLoanId(
  subloanId: string,
): MiddlewareAction {
  return {
    actionName:
      Actions.REQUEST_GET_RETAIL_OD_DRAWDOWN_LOAN_REPAYMENT_SPLIT_BY_SUB_LOAN_ID,
    type: "GET",
    url: `/loans/subloans/${subloanId}/repayments-split`,
  };
}

export function getSubLoansTransformedRepaymentScheduleBySubLoanId(
  subloanId: string,
): MiddlewareAction {
  return {
    actionName:
      Actions.REQUEST_GET_SUB_LOANS_TRANSFORMED_REPAYMENT_SCHEDULE_BY_SUB_LOAN_ID,
    type: "GET",
    url: `/loans/subloans/${subloanId}/transformed-repayment-schedule`,
  };
}

export function getRepaymentCommitmentsByEntityId(
  entityId: string,
): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_GET_REPAYMENT_COMMITMENTS_BY_ENTITY_ID,
    type: "GET",
    url: `/repayment-commitments/${entityId}`,
  };
}
export function closeCreditLineLoanByLoanId(loanId: string): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_CLOSE_CREDIT_LINE_BY_LOAN_ID,
    type: "POST",
    url: `/v1/loans/retail-ods/${loanId}/close`,
  };
}

export function postGenerateLoanStatement(body: {
  entityId: string;
  entityType:
    | Extract<LoanType, "TERM_LOAN" | "RETAIL_OD">
    | "RETAIL_OD_DRAWDOWN";
}): MiddlewareAction {
  return {
    actionName: Actions.REQUEST_POST_GENERATE_LOAN_STATEMENT,
    type: "POST",
    url: "/loan-statements/generate-loan-statement",
    body,
  };
}

export function getUnpaidRepaymentCommitmentAmountByEntityId(
  entityId: string,
): MiddlewareAction {
  return {
    actionName:
      Actions.REQUEST_GET_UNPAID_REPAYMENT_COMMITMENT_AMOUNT_BY_ENTITY_ID,
    type: "GET",
    url: `/repayment-commitments/${entityId}/unpaid-commitment-amount`,
  };
}
